export enum CommissionType {
    TERMINAL = 'TERMINAL',
    ONLINE = 'ONLINE',
    TRANSACTION = 'TRANSACTION',
}

export default CommissionType;
